var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.746 7H3.35436C2.61309 7 2.0127 7.6265 2.0127 8.4V17.5C2.0127 18.2735 2.61309 18.9 3.35436 18.9H12.746C13.4873 18.9 14.0877 18.2735 14.0877 17.5V8.4C14.0877 7.6265 13.4873 7 12.746 7Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3456 2.79883H8.95397C8.2127 2.79883 7.6123 3.42533 7.6123 4.19883V13.2988C7.6123 14.0723 8.2127 14.6988 8.95397 14.6988H18.3456C19.0869 14.6988 19.6873 14.0723 19.6873 13.2988V4.19883C19.6873 3.42533 19.0869 2.79883 18.3456 2.79883Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b4efe50119f56455be31033ce87030ce.svg";
export { ForwardRef as ReactComponent };